import React from 'react'
import { animated, useSpring } from 'react-spring'

import { Primary } from '@cinch/oxd-components/button/src'
import { Search3D } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import Text, { TextStyles } from '@cinch/oxd-components/text/src'

import * as styles from './get-started.module.css'

interface Props {
  i18n: Cinch.WebAppTranslations['lifestyle']['intro']

  onClick: (event: any) => void
}

const GetStarted: React.FC<Props> = ({ onClick, i18n }) => {
  const styleProps = useSpring({
    from: { opacity: 0, transform: 'translateY(-8px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
  })

  return (
    <animated.div style={styleProps} className={styles.block}>
      <SVG children={Search3D} size={90} className={styles.icon} />
      <animated.h1 style={styleProps} className={styles.heading}>
        {i18n.intro}
      </animated.h1>
      <Text element={'p'} type={TextStyles.body1} className={styles.intro}>
        {i18n.body}
      </Text>
      <Primary onClick={onClick} size="large" oxford={true}>
        {i18n.cta}
      </Primary>
    </animated.div>
  )
}

export default GetStarted
